import { PageHeader } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const BravoLogoutIcon = styled(LogoutOutlined)`
  color: var(--primary-color);
`;
export const BravoLogoutIconGrey = styled(LogoutOutlined)`
  color: #20252b;
`;

export const BravoProfileHeader = styled(PageHeader)`
  padding-bottom: 0;
`;
